// 结算信息
import { i18n } from '@/common/utils/i18n'
import { get } from 'lodash-es'

export default (state) => {
  let detailInfo = get(state, 'currentShopBaseDetail', {})
  return {
    title: i18n.gettext('结算信息'),
    content: [
      {
        title: i18n.gettext('持卡人姓名'),
        label: detailInfo.accountHolder
      },
      {
        title: i18n.gettext('持卡人地址'),
        label: detailInfo.accountAddr
      },
      {
        title: i18n.gettext('银行卡号'),
        label: detailInfo.accountCardno
      },
      {
        title: i18n.gettext('开户行'),
        label: detailInfo.accountBankName
      },
      {
        title: i18n.gettext('结算信息照片'),
        content: i18n.gettext('查看'),
        arrow: true,
        isLink: true,
        pics: detailInfo.accountGrantPhoto
      }
    ]
  }
}
